import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './jsx/app.react';
import ErrorBoundary from './jsx/ErrorBoundary.react';
import 'packages/localization/init_i18n';
import '../css/animations.css';
import '../css/base.css';

Sentry.init({
    dsn: 'https://aa35247414cf46c1ef8ce35b643b4e41@o4509707392516096.ingest.de.sentry.io/4509707409883216',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.25,
    beforeSend: event => {
        if (event.request?.headers && event.request.headers['User-Agent']) {
            if (event.request.headers['User-Agent'].indexOf('HeadlessChrome') >= 0) {
                return null;
            }
        }

        if (
            event.exception?.values?.some(
                value => value.type === 'Error' && /Suspense boundary.*hydrating/i.test(value.value || '')
            )
        ) {
            return null;
        }

        const ua = event.request?.headers?.['User-Agent'] || '';
        const isFbWebView = ua.includes('FB_IAB') && ua.includes('Android') && ua.includes('wv');
        const isJavaObjectGone = event.exception?.values?.some(
            value => value.type === 'Error' && /Java object is gone/i.test(value.value || '')
        );

        if (isFbWebView && isJavaObjectGone) {
            return null;
        }

        return event;
    },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);
